import React from 'react';

const NotFound = () => {
  return(
    <div>Whooops...nothing found here</div>
  )
}

export default NotFound;